/**
 * IMA-517: volby cílového trhu – stejné hodnoty jako u strategií (CreateUpdateStrategyModal.vue),
 * aby šlo dluhopisy filtrovat stejnou logikou jako strategie (InvestmentQuestionnaireService).
 * Překlady se berou z klíčů createUpdateStrategyModal.<hodnota>.
 */
export const clientTypes = ['RETAIL', 'PROFESSIONAL', 'AUTHORIZED_OPPOSITE_SIDE'];
export const adequacyTestItems = ['REFUSED_ANSWER', 'BASIC_INVESTOR', 'INFORMED_INVESTOR', 'ADVANCED_INVESTOR'];
export const abilityToLossOptions = ['CAN_LOSE'];
export const riskToleranceCorrectionOptions = [
    {key: 1, value: '1_CONSERVATIVE'},
    {key: 2, value: '2_CONSERVATIVE'},
    {key: 3, value: '3_BALANCED'},
    {key: 4, value: '4_BALANCED'},
    {key: 5, value: '5_BALANCED'},
    {key: 6, value: '6_DYNAMIC'},
    {key: 7, value: '7_DYNAMIC'}
];
export const clientInvestmentGoals = ['PROTECTION_OF_FINANCE', 'FINANCIAL_RESERVE', 'VALUATION'];
export const clientEsg = ['WITHOUT_ESG', 'WITH_ESG'];
export const investmentHorizonOptions = ['NOT_SPECIFIED', 1, 3, 5, 8, 10];
export const investmentPreferences = ['NO_LOSS_GUARANTEE', 'PROTECTION', 'GROWTH'];
